import styled, { keyframes } from "styled-components";

const primary = "#004bff";
const background = "#f2f2f2";
const grey = "#e6e6e6";
const montserrat = (props) => props.theme.fonts.montserrat;

const skeletonLoadingAnimate = keyframes`
  from {
    background-color: hsl(200, 20%, 80%);
  }
  to {
    background-color: hsl(200, 20%, 95%);
  }
`;

export const TitleLoading = styled.div`
  width: 100%;
  height: 12px;
  border-radius: 8px;
  animation: ${skeletonLoadingAnimate} 2s linear infinite;
`;

export const ContractLoading = styled.div`
  width: 64px;
  height: 12px;
  border-radius: 8px;
  animation: ${skeletonLoadingAnimate} 2s linear infinite;
`;

export const ImageLoading = styled.div`
  height: 140px;
  width: 140px;
  border-radius: 9999px;
  animation: ${skeletonLoadingAnimate} 2s linear infinite;
`;

export const ClickHereLink = styled.a`
  color: ${primary};
  text-decoration: none;
  font-weight: bolder;
`;

export const Title = styled.p`
  color: ${primary};
  font-weight: bold;
  color: "#004bff";
`;

export const Container = styled.div`
  max-height: 100vh;
  background-color: ${background};
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TableContainer = styled.div`
  width: 100%;
  max-height: 380px;
  overflow-y: auto;
  scrollbar-color: #303032 #e6e6e6;
  scrollbar-width: thin;
  background-color: ${background};
  &::-webkit-scrollbar {
    background-color: #e6e6e6;
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #303032;
    border-radius: 10px;
  }
  Table {
    thead {
      box-shadow: none !important;
      th {
        background-color: ${grey};
        font-weight: bolder;
        padding: 8px;
      }
    }
    Tbody {
      tr {
        height: 0px !important;
      }
      td {
        font-family: ${montserrat}, sans-serif !important;
      }
    }
  }
  @media only screen and (max-width: 1100px) {
    min-width: 700px;
  }
`;

export const MainGrid = styled.div`
  display: grid;
  width: 100%;
  font-family: ${montserrat};
  grid-template:
    "company boleto boleto boleto"
    "company boleto boleto boleto"
    "support boleto boleto boleto" 100px
    / 350px 1fr;
  max-width: 1400px;
  grid-auto-rows: 100px;
  gap: 32px;
  @media only screen and (max-width: 1100px) {
    grid-template:
      "company" 1fr
      "boleto" auto
      "support" 100px;
    height: 100vh;
  }
`;

export const BoletoGridChild = styled.div`
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 4px;
  padding: 16px;
  grid-column-start: 2;
  grid-column-end: 5;
  grid-row-start: 1;
  grid-row-end: 5;
  grid-area: boleto;
  height: 554px;
`;

export const BoletoHeaderStyle = styled.div`
  width: 100%;
  background-color: ${primary};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
  box-sizing: border-box;
  color: white;
  @media only screen and (max-width: 1100px) {
    min-width: 700px;
  }
`;

export const BoletoHeaderText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const CompanyInfoGridChild = styled.div`
  position: relative;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  height: 100%;

  grid-area: company;
`;

export const CompanyInfoContent = styled.div`
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  text-align: center;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: 0 16px;
  box-sizing: border-box;
`;

export const EmptyBlueHeader = styled.div`
  width: 100%;
  height: 35%;
  background-color: ${primary};
`;

export const CompanyCircleAvatar = styled.div`
  height: 140px;
  width: 140px;
  border-radius: 9999px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  img {
    height: 116px;
    width: 116px;
    background-color: white;
    object-fit: contain;
  }
`;

export const SupportGridChild = styled.div`
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  padding: 20px 28px;
  grid-area: support;
`;
